import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchDataSettingImport = createAsyncThunk('fetchDataSettingImport', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/data-setting-import');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch data setting import'));
  }
});

export const dataSettingImportSlice = createSlice({
  name: 'dataSettingImport',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataSettingImport.fulfilled, (state, action) => {
        state.data = action.payload.data;
      });
  }
});

export const getDataSettingImport = (state) => state.dataSettingImport.data;

export { fetchDataSettingImport };

export default dataSettingImportSlice.reducer;
